<template>
  <div v-if="breadcrumbs.length" class="page-header">
    <BaseBreadcrumb :breadcrumbs="breadcrumbs" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { BaseBreadcrumb } from '@fondationcss/ui'
import { usePageHeaderStore } from '@/stores/page-header-store'

const store = usePageHeaderStore()

// BaseBreadcrumb requires `to` to be a string; default non-linking crumbs to '#'.
const breadcrumbs = computed(() =>
  store.breadcrumbs.map(b => ({ ...b, to: b.to ?? '#' })),
)
</script>

<style scoped>
.page-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  min-height: 40px;
}
</style>
